<template>
  <section>
     <Form :label-width="150">
       <FormItem  label="渠道门店ID：">
          <p>{{data.channelHotelId}}</p>
        </FormItem>
       <FormItem  label="渠道门店名称：">
          <p>{{data.channelHotelName}}</p>
        </FormItem>
       <FormItem  label="联系电话：">
          <p>{{data.contactPhone || '4006099222'}}</p>
        </FormItem>
       <FormItem  label="联系邮箱：">
          <p>{{data.email || 'service@xbed.com.cn'}}</p>
        </FormItem>
       <FormItem  label="省份：">
          <p>{{data.province}}</p>
        </FormItem>
       <FormItem  label="渠道城市ID：">
          <p>{{data.cityId}}</p>
        </FormItem>
       <FormItem  label="城市：">
          <p>{{data.city}}</p>
        </FormItem>
       <FormItem  label="渠道区域ID：">
          <p>{{data.districtId}}</p>
        </FormItem>
       <FormItem  label="区域：">
          <p>{{data.district}}</p>
        </FormItem>
       <FormItem  label="地址：">
          <p>{{data.address}}</p>
        </FormItem>
       <FormItem  label="经度：">
          <p>{{data.longitude}}</p>
        </FormItem>
       <FormItem  label="纬度：">
          <p>{{data.latitude}}</p>
        </FormItem>
       <FormItem  label="备注：">
          <p>{{data.remark}}</p>
        </FormItem>
       <FormItem  label="匹配状态：">
          <p>{{data.matchStatus}}</p>
        </FormItem>
       <FormItem  label="在线状态：">
          <p>{{data.status === 'S01' ? '已上线' : '已下线'}}</p>
        </FormItem>
        <Button type="primary" @click="openEditInfoModal">编辑修改</Button>
        <Button type="info">重新匹配</Button>
        <Button type="error" @click="updateStatus">{{data.status === 'S01' ? '下线门店' : '上线门店'}}</Button>
     </Form>

     <Modal v-model="editInfoModal.display" ref="editInfoModal" :loading="true" :width="1000" title="修改途家渠道门店信息" @on-ok="preEditInfo" ok-text="提交内容" cancel-text="关闭">
      <Form @submit.native.prevent="preventSubmit" ref="editInfoModalForm" :model="editInfoModal" :rules="rules" :label-width="150">
        <FormItem label="渠道门店ID：">
          <p>{{data.channelHotelId}}</p>
        </FormItem>
        <FormItem label="渠道门店名称：" prop="channelHotelName">
          <Input type="text" v-model="editInfoModal.channelHotelName"></Input>
        </FormItem>
        <FormItem  label="联系电话：" prop="contactPhone">
          <Input type="text" v-model="editInfoModal.contactPhone"></Input>
        </FormItem>
       <FormItem  label="联系邮箱：" prop="email">
          <Input type="text" v-model="editInfoModal.email"></Input>
        </FormItem>
       <FormItem  label="省份：">
          <p>{{data.province}}</p>
        </FormItem>
       <FormItem  label="渠道城市ID：">
          <p>{{data.cityId}}</p>
        </FormItem>
       <FormItem  label="城市：">
          <p>{{data.city}}</p>
        </FormItem>
       <FormItem  label="渠道区域ID：">
          <p>{{data.districtId}}</p>
        </FormItem>
       <FormItem  label="区域：">
          <p>{{data.district}}</p>
        </FormItem>
       <FormItem  label="地址：" prop="address">
          <Input type="text" v-model="editInfoModal.address"></Input>
        </FormItem>
       <FormItem  label="经度：" prop="longitude">
          <Input type="text" v-model="editInfoModal.longitude"></Input>
        </FormItem>
       <FormItem  label="纬度：" prop="latitude">
         <Input type="text" v-model="editInfoModal.latitude"></Input>
        </FormItem>
       <FormItem  label="备注：" prop="remark">
          <Input type="text" v-model="editInfoModal.remark"></Input>
        </FormItem>
      </Form>
    </Modal>
  </section>
</template>

<script>
import {emailRegular, contactPhoneRegExp, LngAndLatRegExp} from "@/utils/regular"

export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          channelHotelId: "",
          channelHotelName: "",
          contactPhone: '',
          email: '',
          province: "",
          city: "",
          cityId: '',
          district: "",
          districtId: "",
          address: "",
          longitude: "",
          latitude: "",
          remark: "",
          matchStatus: '',
          status: ''
        }
      }
    }
  },
  data() {
    return {
      editInfoModal: {
        display: false,

      },
      rules: {
          contactPhone: [
            { required: true, message: "联系电话不能为空", trigger: "blur" },
            { type: "string", pattern: contactPhoneRegExp, message: "请填写正确的联系电话" }
          ],
          channelHotelName: [
            { required: true, message: "渠道门店名称不能为空", trigger: "blur" }
          ],
          email: [
            { required: true, message: "联系邮箱不能为空", trigger: "blur" },
            { type: "string", pattern: emailRegular, message: "请填写正确的联系邮箱" }
          ],
          address: [
            { required: true, message: "地址不能为空", trigger: "blur" }
          ],
          longitude: [
            { required: true, message: "经度不能为空", trigger: "blur" },
            { type: "string", pattern: LngAndLatRegExp, message: "请填写正确的经度" }
          ],
          latitude: [
            { required: true, message: "纬度不能为空", trigger: "blur" },
            { type: "string", pattern: LngAndLatRegExp, message: "请填写正确的纬度" }
          ],
          remark: [
            { required: false, type: 'string', max: 255,  message: "备注不能超过255字", trigger: "blur" }
          ]
      }
    };
  },
  methods: {
    openEditInfoModal() {
      this.initEditInfoModal();

      this.editInfoModal.display = true;
    },
    initEditInfoModal() {
      this.editInfoModal = Object.assign({}, this.editInfoModal, {
        channelHotelName: this.data.channelHotelName,
        contactPhone: this.data.contactPhone,
        email: this.data.email,
        address: this.data.address,
        longitude: this.data.longitude,
        latitude: this.data.latitude,
        remark: this.data.remark
      })
    },
    preEditInfo() {
      let validResult = true;
      this.$refs.editInfoModalForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        this.$refs.editInfoModal.buttonLoading = false;
        return;
      }

    },
    updateStatus() {
      if (this.data.status === 'S01') {
        this.confirmUpdateStatus();
        return;
      }
    },
    confirmUpdateStatus() {
      this.$Modal.confirm({
        title: "提示",
        content: "确定将此门店从渠道下线？",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          console.info('下线渠道')
        }
      });
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
  }
};
</script>

<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/pages/ota/tujia/hotel-detail/channel-hotel-info.vue